import { useState } from 'react';
import {
  UncontrolledButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'src/componentes/dropdown';
import Button from 'src/componentes/button';
import ContentManager from 'src/componentes/content-manager';
import ConfirmacaoDevolutiva from '../MensagemConfirmacao/ConfirmacaoDevolutiva';
import ConfirmacaoAprovacao from '../MensagemConfirmacao/ConfirmacaoAprovacao';
import Alert from 'src/componentes/message-box/alert';
import errorHandler from 'src/utils/error-handler';
import http from 'src/services/httpService';
import { useSnackbar } from 'notistack';
import useAuth from 'src/hooks/useAuth';

export default function ButtonAprovarReprovar({
  intl,
  model = {},
  endpoint = '/PerdaOperacional',
  disabled = false,
  validateRequiredFields = () => {},
  handleClose = () => {},
  handleRefresh = () => {},
}) {
  const { terms: resources } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const validarCamposObrigatorios = () => {
    const errors = validateRequiredFields(model);
    const hasError = Array.isArray(errors)
      ? errors.length > 0
      : errors?.hasError || false;

    if (hasError) {
      ContentManager.addContent(
        <Alert
          message={intl.formatMessage({
            id: 'label.osCamposDestacadosEmVermelhoSaoObrigatoriosFavorPreenchelos',
          })}
        />
      );
      return false;
    }
    return true;
  };

  const handleAprovar = async (idsResponsaveisAreasNotificar) => {
    try {
      setIsLoading(true);
      await http.post(`${endpoint}/AprovarAnalise`, {
        model,
        idsResponsaveisAreasNotificar,
      });
      enqueueSnackbar(
        intl.formatMessage({ id: 'labelRegistroAprovadoComSucesso' }),
        {
          variant: 'success',
        }
      );
      handleRefresh();
      handleClose(true);
    } catch (err) {
      errorHandler(err);
      handleClose();
    } finally {
      setIsLoading(false);
    }
  };

  const onAprovarClick = () => {
    if (!validarCamposObrigatorios()) return;

    ContentManager.addContent(
      <ConfirmacaoAprovacao
        modelPerdaOperacional={model}
        intl={intl}
        resources={resources}
        handleConfirm={handleAprovar}
      />
    );
  };

  const onDevolverClick = () => {
    if (!validarCamposObrigatorios()) return;

    ContentManager.addContent(
      <ConfirmacaoDevolutiva
        modelPerdaOperacional={model}
        handleClose={handleClose}
        handleRefresh={handleRefresh}
        resources={resources}
      />
    );
  };

  return (
    <>
      <UncontrolledButtonDropdown>
        <Button
          className="ml-2"
          disabled={isLoading || disabled}
          onClick={onAprovarClick}
        >
          {intl.formatMessage({ id: 'aprovar' })}
        </Button>

        <DropdownToggle
          color="primary"
          split
          disabled={isLoading || disabled}
        />

        <DropdownMenu end>
          <DropdownItem
            onClick={onDevolverClick}
            disabled={isLoading || disabled}
          >
            {intl.formatMessage({ id: 'labelDevolver' })}
          </DropdownItem>
        </DropdownMenu>
      </UncontrolledButtonDropdown>
    </>
  );
}
